import { Header, Item } from 'vue3-easy-data-table'
import { CHART_TYPE, YAXIS_POSITION } from 'xangle-charts'

import {
  ChartListInfo,
  ChartResultInfo,
  type MetricInfo,
  MetricListInfo, TableListInfo,
} from '~/api/repository'
import { ISeriesHelper, ITableHelper } from '~/types/chart-helper.type'
import { getTableHelperByApi } from '~/utils/chart-parser'

export const MetricTableHeader = {
  METIRCS: 'Metrics',
  VALUE: 'Value',
  '7DAY_PER': '7D(%)',
  '1MONTH_PER': '1M(%)',
  '6MONTH_PER': '6M(%)',
  '1YEAR_PER': '1Y(%)',
  'YTD_PER': 'YTD(%)'
}

export class CAnalyticsModel {
  private readonly _name: string
  private readonly _source: string
  private readonly _description: string
  private readonly _chartData: ChartResultInfo[]
  private readonly _tableData: TableListInfo[]
  private readonly _metricInfo: MetricInfo[]
  // private readonly _period: tokenChartPeriodType
  private readonly _isTable: boolean
  private readonly _seriesHelper: ISeriesHelper
  private readonly _tableHelper: ITableHelper
  private readonly _isIndicator: boolean

  constructor(param: ChartListInfo | MetricListInfo, isTable: boolean, helper: ISeriesHelper | ITableHelper, isIndicator?: boolean) {
    if (isTable) {
      const tableParam = param as MetricListInfo
      this._name = tableParam.NM ?? ''
      this._source = tableParam.SR ?? ''
      this._description = tableParam.DESC ?? ''
      this._chartData = []
      this._tableData = tableParam.TBLIST
      this._metricInfo = []
      // this._period = tokenChartPeriodType.ALL
      this._isTable = true
      this._seriesHelper = getSeriesHelperByApi('')
      this._tableHelper = helper as ITableHelper
      this._isIndicator = isIndicator ?? false
    } else {
      const chartParam = param as ChartListInfo
      this._name = chartParam.NM ?? ''
      this._source = chartParam.SR ?? ''
      this._description = chartParam.DESC ?? ''
      this._chartData = chartParam.RETLIST
      this._tableData = []
      this._metricInfo = chartParam.MTCLIST
      // this._period = tokenChartPeriodType.ALL
      this._isTable = false
      this._seriesHelper = helper as ISeriesHelper
      this._tableHelper = getTableHelperByApi('')
      this._isIndicator = isIndicator ?? false
    }
  }

  get title() {
    return this._name
  }

  get source() {
    return this._source
  }

  get description() {
    return this._description
  }

  get isIndicator() {
    return this._isIndicator
  }

  get seriesHelper() {
    return this._seriesHelper
  }

  get tableHelper() {
    return this._tableHelper
  }

  // get period() {
  //   return this._period
  // }
  get isTable() {
    return this._isTable
  }

  get chartData() {
    return this._chartData.map((ele, index) => {
      return {
        name: ele.DATANM,
        yAxis: YAXIS_POSITION.RIGHT,
        type: this._seriesHelper.type[index] ?? CHART_TYPE.LINE,
        stacking: this._seriesHelper.staking,
        unit: this._seriesHelper.unit,
        decimalPoint: this._seriesHelper.decimalPoint,
        data: ele.DATA.map(innerEle => {
          return {
            day: innerEle.TS ?? '',
            value: innerEle.VAL ?? 0
          }
        }) ?? []
      }
    })
  }

  get metricInfo() {
    let headers: Header[] = []
    if (this._isIndicator) {
      headers = [
        {
          text: MetricTableHeader.METIRCS,
          value: 'DATANM',
          width: 150,
          fixed: true,
        },
        {
          text: MetricTableHeader.VALUE,
          value: 'VALUE',
          width: 120,
        },
        {
          text: MetricTableHeader['7DAY_PER'],
          value: 'WEEK',
        },
        {
          text: MetricTableHeader['1MONTH_PER'],
          value: 'MONTH',
        },
        {
          text: MetricTableHeader['6MONTH_PER'],
          value: 'HALF',
        },
        {
          text: MetricTableHeader['1YEAR_PER'],
          value: 'YEAR',
        },
        {
          text: MetricTableHeader.YTD_PER,
          value: 'YTD',
        },
      ]
    } else {
      headers = [
        {
          text: MetricTableHeader.VALUE,
          value: 'VALUE',
        },
        {
          text: MetricTableHeader['7DAY_PER'],
          value: 'WEEK',
        },
        {
          text: MetricTableHeader['1MONTH_PER'],
          value: 'MONTH',
        },
        {
          text: MetricTableHeader['6MONTH_PER'],
          value: 'HALF',
        }
      ]
    }
    const items: Item[] = []
    if (this._metricInfo.length > 0) {
      this._metricInfo.forEach(ele => {
        const result: Record<string, string | number> = {}
        result.DATANM = ele.DATANM
        ele.DATA.forEach(innerEle => {
          result[innerEle.TFRMTP] = innerEle.VAL
        })
        items.push(result)
      })
    }
    // console.log(items)
    return {
      headers,
      items
    }
  }

  get tableData() {
    const headers = this._tableHelper.columnList
    let items: any[] = []
    if (this._tableData) {
      items = this._tableData.length > 0 ? this._tableData[0].DATA : []
    } else {
      // console.log(this._metricInfo)
      // console.log(this._tableHelper)
      // this._metricInfo.forEach((ele, idx) => {
      //
      // })
    }
    // const items = this._tableData.length > 0 ? this._tableData[0].DATA : []
    return {
      headers,
      items
    }
  }
}